import { ErrorMessage } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

export const TextFieldFormGroup: React.FC<{
  fieldName: string;
  fieldDisplayName: string;
  placeholder?: string;
  error?: string;
  value?: string;
  disabled: boolean;
  controlAs?: "input" | "textarea";
  rows?: number;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(
      field: T_1
    ): T_1 extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  className?: string;
}> = (props) => {
  return (
    <Form.Group className={props.className}>
      <Form.Label>{props.fieldDisplayName}</Form.Label>
      {props.controlAs === "textarea" ? (
        <Form.Control
          as="textarea"
          rows={props.rows}
          isInvalid={props.error != null}
          name={props.fieldName}
          placeholder={props.placeholder}
          value={props.value ?? ""}
          disabled={props.disabled}
          onChange={props.handleChange}
        />
      ) : (
        <Form.Control
          as={props.controlAs}
          isInvalid={props.error != null}
          name={props.fieldName}
          placeholder={props.placeholder}
          value={props.value ?? ""}
          disabled={props.disabled}
          onChange={props.handleChange}
        />
      )}
      <ErrorMessage
        name={props.fieldName}
        component={Form.Text}
        className="text-danger"
      />
    </Form.Group>
  );
};
